// Discovery Education serves asset thumbnails/banner images via a CloudFront CDN,
// keyed by asset GUID, with no API call required.
const THUMBNAIL_CDN_BASE_URL = 'https://d1m0scxbrw6oep.cloudfront.net/thumbnails';

export const DEFAULT_THUMBNAIL_SIZE = 'bannerxlarge';

/**
 * Builds a Discovery Education CDN thumbnail URL for an asset GUID.
 *
 * @param {string} guid - The DE asset GUID.
 * @param {string} [size=DEFAULT_THUMBNAIL_SIZE] - Image size (e.g. medium, large, xlarge, bannerxlarge).
 * @returns {string|null} The thumbnail URL, or null if no GUID was provided.
 */
export const getThumbnailUrl = (guid, size = DEFAULT_THUMBNAIL_SIZE) => {
    if (!guid) {
        return null;
    }

    return `${THUMBNAIL_CDN_BASE_URL}/${guid}-${size}`;
};

export default getThumbnailUrl;
